import React from 'react';

import { cn } from '@/lib/utils';

export type RecordType = 'Records' | 'Bills';

interface ProvidedRecordsDisplayProps {
  records: string[];
  className?: string;
}

export const ProvidedRecordsDisplay: React.FC<ProvidedRecordsDisplayProps> = ({
  records,
  className,
}) => {
  if (records.length === 0) return null;

  return (
    <div className={cn('text-sm font-semibold text-gray-800', className)}>
      Request for {records.join(' + ')}
    </div>
  );
};
